import React from 'react';
import styled from 'styled-components';
import { visuallyHidden } from '../styles';
import SpaItems from './SpaItems';
import Pagination from './Pagination';
import IconContent from './IconContent';

const StyledSpaList = styled.section``;

const StyledHeading = styled.h2`
  ${visuallyHidden()};
`;

const StyledItems = styled(SpaItems)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SpaList = ({
  heading,
  items,
  baseUrl,
  meta,
  arePackages,
  isClientSide,
  ...props
}) => (
  <StyledSpaList {...props}>
    {items && items.length > 0 ? (
      <>
        {heading && <StyledHeading>{heading}</StyledHeading>}
        <StyledItems items={items} arePackages={arePackages} isSpaList={true} />
        <Pagination
          baseUrl={baseUrl}
          currentPage={meta && meta.currentPage}
          totalPages={meta && meta.totalPages}
          isClientSide={isClientSide}
        />
      </>
    ) : (
      <IconContent
        heading="No spas found…"
        text="<p>Please amend your filters or search again.</p>"
      />
    )}
  </StyledSpaList>
);

export default SpaList;
